module.exports = __webpack_public_path__ + "static/blog72-b17e1349f5bbf0a6a8cfff353b4f7db7.png";